var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tw-hidden md:tw-flex tw-mb-0 tw-text-grey-600"},[_vm._v("\n  "+_vm._s(_vm.description)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }